module.exports = __webpack_public_path__ + "static/media/thomas-hobbs-florist.bbbd857b.jpg";